import React from 'react';
import Link from '../../atoms/link';
import Checkbox from '../../atoms/checkbox';
import { Reference } from 'types/reference';

export interface TermsAndConditionsProps {
  mainText: React.ReactNode;
  termsLabel: React.ReactNode;
  termsUrl: string | Reference;
  andText: React.ReactNode;
  privacyLabel: React.ReactNode;
  privacyUrl: string | Reference;
  checkbox?: boolean;
  checked?: boolean;
  onCheck?: (checked: boolean) => void;
  checkboxId?: string;
  className?: string;

  // trigger custom rendering
  renderText?: (props?: TermsAndConditionsProps) => React.ReactNode;
}

const TermsAndConditions: React.FC<TermsAndConditionsProps> = (props) => {
  const {
    mainText,
    termsLabel,
    termsUrl,
    andText,
    privacyLabel,
    privacyUrl,
    checkbox = false,
    checked = false,
    onCheck,
    checkboxId = 'terms-checkbox',
    className = '',
    renderText,
  } = props;
  if (renderText) return <>{renderText(props)}</>;

  const content = (
    <>
      {mainText}{' '}
      <Link
        link={termsUrl}
        className="!text-14 font-bold no-underline"
        variant="primary"
        target="_blank"
        rel="noopener noreferrer"
      >
        {termsLabel}
      </Link>{' '}
      {andText}{' '}
      <Link
        link={privacyUrl}
        className="!text-14 font-bold no-underline"
        variant="primary"
        target="_blank"
        rel="noopener noreferrer"
      >
        {privacyLabel}
      </Link>
      .
    </>
  );

  if (checkbox) {
    return (
      <div className={`flex items-start gap-8 ${className}`}>
        <Checkbox id={checkboxId} className="!self-start" checked={checked} onChange={() => onCheck?.(!checked)} />
        <label className="body-text-small cursor-pointer !leading-5" htmlFor={checkboxId}>
          {content}
        </label>
      </div>
    );
  }

  return <div className={`body-text-small text-text-primary ${className}`}>{content}</div>;
};

export default TermsAndConditions;
